import { render, staticRenderFns } from "./EditBranchForm.vue?vue&type=template&id=c55201ba"
import script from "./EditBranchForm.vue?vue&type=script&lang=js"
export * from "./EditBranchForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports